module.exports = __webpack_public_path__ + "static/media/loading.439320ac.gif";